<!-- ACCUEIL -->
<mdb-accordion-item class="no-collapse">
  <mdb-accordion-item-head
    mdbWavesEffect
    [indicator]="false"
    [routerLink]="PATHS.USER_MY_DASHBOARD.path"
    [routerLinkActiveOptions]="{ exact: true }"
    routerLinkActive="active-link"
  >
    <jhi-bary-icon icon="home" [faDirective]="FAS"></jhi-bary-icon>
    <span jhiTranslate="SIDEBAR.USER.DASHBOARD" data-id-cypress="sidebar-user-dashboard">Dashboard</span>
  </mdb-accordion-item-head>
</mdb-accordion-item>

<!-- BASKET -->
<mdb-accordion-item class="no-collapse">
  <mdb-accordion-item-head [indicator]="false" mdbWavesEffect [routerLink]="PATHS.ORDER_BASKET.path" [routerLinkActiveOptions]="{ exact: true }" routerLinkActive="active-link">
    <jhi-bary-icon icon="shopping-cart" [faDirective]="FAS"></jhi-bary-icon>
    <span jhiTranslate="SIDEBAR.USER.BASKET" data-id-cypress="sidebar-user-basket">Basket</span>
  </mdb-accordion-item-head>
</mdb-accordion-item>

<!-- MES TRANSPORTS -->
<mdb-accordion-item class="no-collapse">
  <mdb-accordion-item-head [indicator]="false" mdbWavesEffect [routerLink]="PATHS.USER_MY_TRANSPORTS.path" routerLinkActive="active-link">
    <jhi-bary-icon icon="shipping-fast" [faDirective]="FAS"></jhi-bary-icon>
    <span jhiTranslate="SIDEBAR.USER.TRANSPORT" data-id-cypress="sidebar-user-transports">Transports</span>
  </mdb-accordion-item-head>
</mdb-accordion-item>

<!-- MES DEVIS -->
<mdb-accordion-item class="no-collapse">
  <mdb-accordion-item-head
    mdbWavesEffect
    [indicator]="false"
    [routerLink]="PATHS.USER_MY_QUOTATION.path"
    routerLinkActive="active-link"
    [routerLinkActiveOptions]="{ exact: false }"
  >
    <jhi-bary-icon icon="file-circle-question" [faDirective]="FAS"></jhi-bary-icon>
    <span data-id-cypress="sidebar-user-quotations" jhiTranslate="SIDEBAR.USER.QUOTATION">Quotations</span>
  </mdb-accordion-item-head>
</mdb-accordion-item>

<!-- MES FACTURES -->
<mdb-accordion-item class="no-collapse">
  <mdb-accordion-item-head mdbWavesEffect [indicator]="false" [routerLink]="PATHS.USER_MY_BILLS.path" routerLinkActive="active-link">
    <jhi-bary-icon icon="receipt" [faDirective]="FAS"></jhi-bary-icon>
    <span jhiTranslate="SIDEBAR.USER.BILL" data-id-cypress="sidebar-user-bills">Bills</span>
  </mdb-accordion-item-head>
</mdb-accordion-item>

<!-- MES ADRESSES -->
<mdb-accordion-item class="no-collapse">
  <mdb-accordion-item-head mdbWavesEffect [indicator]="false" [routerLink]="PATHS.USER_MY_REGISTERED_ADDRESSES.path" routerLinkActive="active-link">
    <jhi-bary-icon icon="book-atlas" [faDirective]="FAS"></jhi-bary-icon>
    <span jhiTranslate="SIDEBAR.USER.ADDRESS">Adresses</span>
  </mdb-accordion-item-head>
</mdb-accordion-item>
<!-- MES CONTACTS -->
<mdb-accordion-item class="no-collapse">
  <mdb-accordion-item-head mdbWavesEffect [indicator]="false" [routerLink]="PATHS.USER_MY_CONTACTS.path" routerLinkActive="active-link">
    <jhi-bary-icon icon="address-card" [faDirective]="FAS"></jhi-bary-icon>
    <span jhiTranslate="SIDEBAR.USER.CONTACT">Mes contacts</span>
  </mdb-accordion-item-head>
</mdb-accordion-item>
